import create from 'zustand'

interface CompanySelectStoreState {
  isSwitchingCompany: boolean
}

interface CompanySelectStoreActions {
  setIsSwitchingCompany: (isSwitchingCompany: boolean) => void
}

interface CompanySelect extends CompanySelectStoreState, CompanySelectStoreActions {}

export const useCompanySelectStore = create<CompanySelect>((set, get) => ({
  isSwitchingCompany: false,
  setIsSwitchingCompany: (isSwitchingCompany: boolean) =>
    set(() => {
      return { isSwitchingCompany }
    }),
}))
